import { RootState } from '@Store/index';
import { getPurchaseStatusesDictSelector } from '@Store/selectors/dictionarySelector';
import { prepareRequisitionInfo } from '@Utils/requisitionInfo';
import { createSelector } from '@reduxjs/toolkit';

const purchaseRequest = (state: RootState) =>
  state.featureStores.purchaseRequest;

const currentPurchaseRequest = createSelector(
  purchaseRequest,
  ({ purchaseRequest }) => purchaseRequest
);

const currentOverviewItems = createSelector(
  purchaseRequest,
  ({ purchaseOverviewItems }) => purchaseOverviewItems
);

const currentSelectedOverviewItems = createSelector(
  purchaseRequest,
  ({ selectedOverviewItems }) => selectedOverviewItems
);

const createdTender = createSelector(
  purchaseRequest,
  ({ createdTenderId }) => createdTenderId
);

const purchaseRequestCreateRequisitionInfo = createSelector(
  [currentPurchaseRequest, getPurchaseStatusesDictSelector],
  (purchaseRequest, statuses) => {
    const requisitionInfo = prepareRequisitionInfo(purchaseRequest, statuses);
    return requisitionInfo;
  }
);

export const getStatusLabels = createSelector(
  getPurchaseStatusesDictSelector,
  (statuses) => statuses.map((status) => status.codeDesc)
);

export {
  currentPurchaseRequest,
  purchaseRequestCreateRequisitionInfo,
  currentOverviewItems,
  currentSelectedOverviewItems,
  createdTender,
};
